<template>
	<div class="page">
		<div class="pageTitleBox" style="align-items: center;">
			<div class="boxNameL">
				编辑药品
			</div>
			<el-button type="warning" @click="isBack" size="small">返回</el-button>
		</div>

		<div class="con">

			<el-form :model="editParams" :rules="rules" ref="ruleForm" label-width="130px" class="demo-ruleForm">
				<div class="tit">
					<span class="name">基础设置</span>
				</div>
				<el-form-item label="商品分类" prop="productTypeIds" class="formitem" v-if="categoryData.length > 0">
					<el-cascader size="mini" filterable ref="cascader" clearable v-model="productTypeIds"
						:options="categoryData[0].children" :show-all-levels="true"
						:props="{ label: 'label', value: 'id' }" @change="changeCategory"></el-cascader>
				</el-form-item>
				<el-form-item label="品牌名:" class="formitem mandatory" prop="brand_name">
					<el-autocomplete class="inline-input" v-model="editParams.brand_name" value-key="name"
						:fetch-suggestions="querySearch" placeholder="请输入内容" size='mini'
						@select="handleSelect"></el-autocomplete>
				</el-form-item>
				<el-form-item label="适用品种" class="formitem" prop="category_of">
					<el-radio-group v-model="editParams.applyType">
						<el-radio label="0">通用</el-radio>
						<el-radio label="1">猫用</el-radio>
						<el-radio label="2">犬用</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="药品名称" class="formitem" prop="title">
					<el-input v-model="editParams.title" size="mini" style="width: 180px;"
						placeholder="药品名称"></el-input>
				</el-form-item>
				<el-form-item label="医学名称" class="formitem" prop="medical_name">
					<el-input v-model="editParams.medical_name" size="mini" style="width: 200px;"
						placeholder="医学名称"></el-input>
				</el-form-item>
				<el-form-item label="打印名称" prop="other_name">
					<el-input v-model="editParams.other_name" size="mini" style="width: 200px;"
						placeholder="打印名称"></el-input>
				</el-form-item>
				<el-form-item label="是否是兽用药" label-width="130px" class="formitem" prop="is_human_medication">
					<el-radio-group v-model="editParams.is_human_medication">
						<el-radio :label="Number(1)">是</el-radio>
						<el-radio :label="Number(0)">否</el-radio>
					</el-radio-group>
				</el-form-item>
				<storeSelect v-if='showShops' title='应用门店' :storeIds='storeIds' @sendStore='getStores'></storeSelect>
				<div class="tit">
					<span class="name">其他</span>
				</div>
				<el-form-item label="销售价" prop="min_stock" class="formitem">
					<el-input type="number" v-model="editParams.pprice" size="mini" style="width: 100px;"
						placeholder="请输入销售价"></el-input>
				</el-form-item>
				<el-form-item label="会员销售价" prop="mprice" class="formitem">
					<el-input type="number" v-model.number="editParams.mprice" size="mini" style="width: 100px;"
						placeholder="请输入会员销售价"></el-input>
				</el-form-item>
				<el-form-item label="规格名称" class="formitem">
					<el-input v-model="editParams.old_packinfo_info.sku_value" size="mini" style="width: 100px;"
						placeholder="请输入规格名称"></el-input>
				</el-form-item>
				
				<el-form-item label="最大出库单位出售" label-width="130px" class="formitem" prop="allow_wholesale">
					<el-radio-group v-model="editParams.medical_ext_info.allow_wholesale">
						<el-radio :label="Number(1)">是</el-radio>
						<el-radio :label="Number(0)">否</el-radio>
					</el-radio-group>
					<span class="m-l-10 color-969799 f-12">默认否</span>
				</el-form-item>
				<el-form-item label="入库单位 " class="formitem">
					<el-input-number @change="inexChanage" size="mini"
						v-model="editParams.old_packinfo_info.in_exchanage" style="width: 100px;"
						:min="0"></el-input-number>
					<el-select filterable style="width: 70px;margin-left: 10px;" clearable size='mini'
						v-model="editParams.old_packinfo_info.unit" placeholder="请选择">
						<el-option v-for="item in unitData.orderUnit" :key="item.name" :label="item.name"
							:value="item.name">
						</el-option>
					</el-select>
					<span class="m-l-10 color-969799 f-12">每</span>
					<el-select filterable style="width: 70px;margin-left: 10px;" clearable size='mini'
						v-model="editParams.old_packinfo_info.in_unit" placeholder="请选择">
						<el-option v-for="(item, num) in unitData.inUnit" :key="num" :label="item.name"
							:value="item.name">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="包装规格" class="formitem" prop="out_unit">
					<el-input size="mini" v-model="editParams.old_packinfo_info.guige_exchanage_min"
						style="width: 100px;" placeholder="10"></el-input>
					<el-select filterable style="width: 70px;margin-left: 10px;" clearable size='mini'
						v-model="editParams.old_packinfo_info.guige_unit_min" placeholder="请选择">
						<el-option v-for="(item, key) in unitData.orderUnit" :key="key" :label="item.name"
							:value="item.name">
						</el-option>
					</el-select>
					/
					<el-select filterable style="width: 70px;margin-left: 10px;" clearable size='mini'
						v-model="editParams.old_packinfo_info.guige_unit_max" placeholder="请选择">
						<el-option v-for="(item, index) in unitData.inUnit" :key="index" :label="item.name"
							:value="item.name">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="换算单位 " class="formitem">
					<el-input size="mini" v-model="editParams.old_packinfo_info.unit_changesrc" style="width: 100px;"
						placeholder="1支"></el-input>
					=
					<el-input size="mini" v-model="editParams.old_packinfo_info.unit_changedesc" style="width: 100px;"
						placeholder="100ml"></el-input>
				</el-form-item>
				<el-form-item label="用量向上取整" class="formitem" prop="dosage_ceiling">
					<el-radio-group v-model="editParams.medical_ext_info.dosage_ceiling" @change="changeDosageCeiling">
						<el-radio :label="Number(1)">取整</el-radio>
						<el-radio :label="Number(0)">不取整</el-radio>
					</el-radio-group>
					<div class="m-l-10 color-969799 f-12" style="line-height: 24px;">默认不取整 explan:若取整，请输入临界值</div>
				</el-form-item>
				<el-form-item label="向上取整临界值" label-width="120px" class="" prop="dosage_ceiling_value"
					v-if="editParams.medical_ext_info.dosage_ceiling == 1">
					<el-input-number size="mini" v-model="editParams.medical_ext_info.dosage_ceiling_value"
						:min="0"></el-input-number>
				</el-form-item>
				<el-form-item label="使用次数" class="formitem">
					<el-input-number size="mini" v-model="editParams.medical_ext_info.use_times"
						:min="0"></el-input-number>
				</el-form-item>
				<el-form-item label="时效性 " class="formitem" prop="time_useable">
					<el-input size="mini" v-model="editParams.medical_ext_info.time_useable"
						style="width: 80px;"></el-input> 分钟
					<span class="m-l-10 color-969799 f-12">(默认0,针对药品)</span>
				</el-form-item>
				<el-form-item label="最小库存预警 " prop="min_stock" class="formitem">
					<el-input v-model.number="editParams.stock_alert" size="mini" style="width: 100px;"
						placeholder="请输入库存下限"></el-input>
				</el-form-item>
				<el-form-item label="是否复购">
					<el-radio-group v-model="editParams.buy_back">
						<el-radio :label="1">是</el-radio>
						<el-radio :label="0">否</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="状态" v-if="id != undefined">
					<el-radio-group v-model="editParams.status">
						<el-radio :label="1">启用</el-radio>
						<el-radio :label="0">暂停</el-radio>
						<el-radio :label="-1">作废</el-radio>
					</el-radio-group>
				</el-form-item>
			</el-form>


		</div>
		<div class="footer">
			<div style="margin: auto;">
				<el-button size="small" type="primary" @click="onSubmit('ruleForm')">提交</el-button>
			</div>
		</div>
	</div>
</template>

<script>

import { // VUE_APP_Url_baseData
	getProductTypeList,  // api.get(`${baseURL2}api/dict/ProductType/tree`
	getProductTypeDl,  // ${baseURL2}api/dict/ProductType/codemodel
	getBrandInfoList,  // api.post(`${baseURL2}api/dict/BrandInfo/list`
	getUnitType,  // api.get(`${baseURL2}api/dict/UnitType/type/list`
	getUnitList,  // api.post(`${baseURL2}api/dict/UnitType/list`  
	setProductMedical,  // api.post(`${baseURL2}api/product/medical/update`
	getProductMedicalDl  // api.get(`${baseURL2}api/product/medical`
} from '../../../api/productApi.js'
import storeSelect from "../../../components/storeSelect.vue"
export default {
	components: {
		storeSelect,
	},
	data() {
		return {
			id: this.$route.query.id,
			rules: {

				title: [{
					required: true,
					message: '不能为空',
					trigger: 'blur'
				}],

			},
			showShops: true,
			categoryData: [],
			productTypeIds: [],
			editParams: {
				medical_id: '',
				category_info: {
					_id: '',
					name: '',
					code: '',
				},
				buy_back: 1,
				category_list: [],
				brand_name: '',
				old_packinfo_info: {
					guige_exchanage_min: 1,
					guige_unit_min: '',
					guige_unit_max: '',
					unit_changesrc: '',
					unit_changedesc: '',
					in_unit: '',
					in_exchanage: 0,
					unit: '',
					out_exchanage: 0,
					out_unit: '',
					sku_value: '',
					is_human_medication:0,
				},
				medical_ext_info: {
					allow_wholesale: 1,
					dosage_ceiling: 0,
					dosage_ceiling_value: 0,
					use_times: 1,
					time_useable: 0,
					
				},
				stock_alert: 1,
				applyType: '0',
				title: '',
				medical_name: '',
				other_name: '',
				pprice: 0,
				mprice:0,
				remark: '',
				shop_info: [],
				status: 1
			},
			brandList: [],
			unitData: {
				inUnit: [],
				outUnit: [],
				orderUnit: [],
			},
			storeIds: [],
		}
	},
	created() {
		this.getProductTypeList();
		this.getUnit();
		if (this.$route.query.id) {
			this.getProductMedicalDl(this.$route.query.id)
		} else {
			this.storeIds = this.$store.state.userInfo.shops.map(item => {
				return item.shop_id
			})
			this.editParams.shop_info = this.$store.state.userInfo.shops
		}
	},
	methods: {
		isBack() {
			this.$confirm('是否退出当前页面？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$router.push({
					path: '/medical/medical'
				})

			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消'
				});
			});
		},
		getProductTypeList() {
			getProductTypeList({
				category: '医疗'
			}).then(res => {
				if (res.code == 0) {
					this.categoryData = res.data;
				}
			})
		},
		changeCategory(val) {
			if (val.length > 0) {
				getProductTypeDl({
					id: val[val.length - 1]
				}).then(res => {
					if (res.code == 0) {
						this.editParams.category_info._id = res.data._id;
						this.editParams.category_info.name = res.data.name;
						this.editParams.category_info.code = res.data.code;
						this.editParams.category_list = res.data.parent_all;
					}
				})
			}
		},
		handleSelect(val) {
			this.editParams.brand_name = val.name;
		},
		querySearch(queryString, cb) {
			this.getBradList(queryString)
			this.timeout = setTimeout(() => {
				let goodsData = this.brandList;
				cb(goodsData);
			}, 1000)

		},
		getBradList(keyword) {
			getBrandInfoList({
				keyword,
				pageIndex: 0,
				pageSize: 0
			}).then(res => {
				this.brandList = res.data.data;
			})
		},
		getUnit() {
			getUnitType().then(res => {
				if (res.code == 0) {
					res.data.forEach(item => {
						getUnitList({
							unitType: item
						}).then(response => {
							if (item == '入库单位') {
								this.unitData.inUnit = response.data.data;
							} else if (item == '出库单位') {
								this.unitData.outUnit = response.data.data;
							} else if (item == '销售单位') {
								this.unitData.orderUnit = response.data.data;
							}
							// console.log(response)
						})
					})
				}
			})
		},
		inexChanage(val) {
			if (this.params.allow_wholesale == 0) {
				this.editParams.old_packinfo_info.out_exchanage = val;
			}
		},
		changeDosageCeiling(val) {
			if (val == 1) {
				this.editParams.medical_ext_info.dosage_ceiling_value = 0.1;
			} else {
				this.editParams.medical_ext_info.dosage_ceiling_value = 0.1;
			}
		},
		getStores(data) {
			this.editParams.shop_info = data;
		},
		onSubmit(formName) {
			console.log(formName,'this.$refs[formName]----------');
			// this.$refs[formName].validate((valid) => {
			// 	if (valid) {
			// 		setProductMedical(
			// 			this.editParams
			// 		).then(res => {
			// 			if (res.code == 0) {
			// 				this.$message({
			// 					message: '设置成功',
			// 					type: 'success'
			// 				});
			// 				this.$router.push({
			// 					path: '/chanpin/medical'
			// 				})
			// 			}
			// 		})
			// 	} else {
			// 		console.log('error submit!!');
			// 		return false;
			// 	}
			// });
			this.$confirm(
				"<div>名称：" + this.editParams.brand_name + this.editParams.title + (this.editParams.buy_back === 1 ? ' 复购' : '') + "</div>" +
				// "<div>规格："+this.editParams.old_packinfo_info.in_exchanage+this.editParams.old_packinfo_info.unit+"/"+this.editParams.old_packinfo_info.in_unit+"</div>"+
				"<div>价格：" + (this.editParams.medical_ext_info.allow_wholesale === 1 ? this.editParams.pprice : this.$public.chu(this.editParams.pprice, this.editParams.medical_ext_info.use_times)) + "元/" + (this.editParams.medical_ext_info.allow_wholesale === 1 ? this.editParams.old_packinfo_info.in_unit : this.editParams.old_packinfo_info.unit) + "</div>" +
				"<div>会员价格：" + (this.editParams.medical_ext_info.allow_wholesale === 1 ? this.editParams.mprice : this.$public.chu(this.editParams.mprice, this.editParams.medical_ext_info.use_times)) + "元/" + (this.editParams.medical_ext_info.allow_wholesale === 1 ? this.editParams.old_packinfo_info.in_unit : this.editParams.old_packinfo_info.unit) + "</div>"+"<div>每" + this.editParams.old_packinfo_info.in_unit + "可使用" + this.editParams.medical_ext_info.use_times + "次</div>",
				'请再次确认以下药品信息',
				{
					dangerouslyUseHTMLString: true,
					confirmButtonText: '确认无误，并提交',
					cancelButtonText: '设置错误，立即修改',
					type: 'info'
				}
			).then(() => {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						setProductMedical(
							this.editParams
						).then(res => {
							if (res.code == 0) {
								this.$message({
									message: '设置成功',
									type: 'success'
								});
								this.$router.push({
									path: '/medical/medical'
								})
							}
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			})
		},
		getProductMedicalDl(id) {
			this.showShops = false;

			getProductMedicalDl({ id, }).then(res => {
				if (res.code == 0) {
					console.log('详情', res.data)
					this.productTypeIds = [];
					this.editParams = res.data;
					res.data.category_list.forEach((item, index) => {
						if (index > 0) {
							this.productTypeIds.push(item._id)
						}
					})
					this.productTypeIds.push(res.data.category_info._id);
					this.storeIds = this.editParams.shop_info.map(item => {
						return item.shop_id
					})
					this.showShops = true;

					console.log(this.productTypeIds)
				}
			})
		},
	},

}
</script>

<style lang="scss" scoped="scoped">
.page {
	padding-bottom: 50px;

	.tit {
		font-size: 16px;
		margin-bottom: 28px;
		background-color: #f5f5f5;
		height: 40px;
		line-height: 40px;
		border-radius: 3px;
		padding-left: 10px;

		.name {
			padding-left: 5px;
			border-left: 2px solid #F5882A;
		}
	}

	.formitem {
		margin-bottom: 0px;
	}

	.footer {
		background-color: #f5f5f5;
		position: fixed;
		bottom: 0;
		height: 50px;
		line-height: 50px;
		display: flex;
		justify-content: space-between;
		left: 140px;
		right: 0;
		padding-left: 20px;
		z-index: 200;
	}
}
</style>
